/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_CreatorInputs */

const en_story_creator = /** @type {(inputs: Story_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const es_story_creator = /** @type {(inputs: Story_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador`)
};

const fr_story_creator = /** @type {(inputs: Story_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur`)
};

const de_story_creator = /** @type {(inputs: Story_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator`)
};

const id_story_creator = /** @type {(inputs: Story_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreator`)
};

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const ja_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const zh_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const ar_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const it_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const ru_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const pt_story_creator = en_story_creator;

/** @type {(inputs: Story_CreatorInputs) => LocalizedString} */
const ko_story_creator = en_story_creator;

/**
* | output |
* | --- |
* | "Creator" |
*
* @param {Story_CreatorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_creator = /** @type {((inputs?: Story_CreatorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_CreatorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_creator(inputs)
	if (locale === "es") return es_story_creator(inputs)
	if (locale === "fr") return fr_story_creator(inputs)
	if (locale === "de") return de_story_creator(inputs)
	if (locale === "ja") return ja_story_creator(inputs)
	if (locale === "zh") return zh_story_creator(inputs)
	if (locale === "ar") return ar_story_creator(inputs)
	if (locale === "id") return id_story_creator(inputs)
	if (locale === "it") return it_story_creator(inputs)
	if (locale === "ru") return ru_story_creator(inputs)
	if (locale === "pt") return pt_story_creator(inputs)
	return ko_story_creator(inputs)
});